import { TextContainer, Link } from '@shopify/polaris'

const Instructions = () => <TextContainer>
  <div className="title" style={{ fontSize: '28px', fontWeight: 600, lineHeight: '32px' }}>Set up your Content A/B test</div>
  <p> Setting up your A/B test is simple. To get started, give your test a name (your visitors won’t see this name) and then the visual content editor will be opened.</p>
  <p>For more detailed information on how to set up your test, refer to the <Link external url="https://tridentab.zendesk.com/hc/en-us/articles/4402051427223-How-do-I-create-my-first-A-B-test-">test instructions</Link></p>
</TextContainer>

export default Instructions
